import { FormikInput } from "shared/components/FormikInput"
import { WrapperFormProfile } from "shared/styles/GlobalStyle"
import { GeneralData } from "../../consts/SubPersonal/GeneralData"

export const GeneralDataInput = () => {
    return (
        <WrapperFormProfile>
            <div className="title">Общие данные</div>
            <div className="container">
                    {GeneralData.map((data, index) => (
                        <div className="row" key={index}>
                            {data.map((item: any, index) => (
                                <FormikInput
                                    required={item.required}
                                    key={index}
                                    name={item.name}
                                    label={item.label}
                                    placeholder={item.placeholder}
                                    type={item.type}
                                    disabled={item.disabled ? true : false}
                                    value={item.value && item.value}
                                    maskConfig={item.maskConfig}
                                    className="inputForm"
                                    $afterIcon="clearInput"
                                />
                            ))}
                        </div>
                    ))}
            </div>
        </WrapperFormProfile>
    )
}